import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false;

import '@/assets/css/tailwind.css';
import {rtdbPlugin} from 'vuefire'

Vue.use(rtdbPlugin);
require('./db.js' )

import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {required, numeric, min} from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'This field is required'
})
;extend('numeric', {
  ...numeric,
  message: 'Must be a number'
});
extend('min', {
  ...min,
  message: 'Minimum of 11 '
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

import VueToast from 'vue-toast-notification';
// Import any of available themes
import 'vue-toast-notification/dist/theme-default.css';
//import 'vue-toast-notification/dist/theme-sugar.css';

Vue.use(VueToast,{
  position: 'top-right',
  duration: 5000
});

import VueSimpleAlert from "vue-simple-alert";

Vue.use(VueSimpleAlert);

new Vue({
  render: h => h(App),
}).$mount('#app')
